const CmsLayout = () =>
  import(
    /* webpackChunkName: "cms-layout" */ '@/pages/cms/content/layout/index.vue'
  )
const CreateCmsLayout = () =>
  import(
    /* webpackChunkName: "cms-layout" */ '@/pages/cms/content/layout/create.vue'
  )
const EditCmsLayout = () =>
  import(
    /* webpackChunkName: "cms-layout" */ '@/pages/cms/content/layout/edit.vue'
  )

export default {
  path: 'layout',
  meta: {
    label: 'layout',
    auth: 'layout'
  },
  component: {
    name: 'Layout',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsLayoutReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CmsLayout
    },
    {
      name: 'CmsCreateLayout',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCmsLayout
    },
    {
      name: 'CmsEditLayout',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCmsLayout,
      props: true
    }
  ]
}
